import React, { Component } from 'react';
import PageBanner from '../../../layout/PageBanner';
import Gallery from './gallery';
import { Link } from 'react-router-dom';

class multimediaDetalle extends Component {
  constructor() {
    super();
    this.state = {
      textPropInt: "new data",
      galleryNumber: 0
    }
    this.setGalleryNumber = this.setGalleryNumber.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0)
    this.setState({
      galleryNumber: this.props.location.state.number
    })
  }

  setGalleryNumber = (item) => {

    if (item !== this.state.galleryNumber){
      this.setState({
        galleryNumber: item
      })  
    }
  }

  

  render() {
    return (
      <div>
        <div>
          <PageBanner title="Album Multimedia" img="banner-multimedia.jpeg">
            <Link to="/">Home</Link>
            <Link to="/multimedia">Multimedia</Link>
            <a>{this.props.location.state.title}</a>
          </PageBanner>

          <section className="about-ds">
            <div className="container">
              <div className="section-header03">
                <h2 dangerouslySetInnerHTML={{ __html: this.props.location.state.gallery[this.state.galleryNumber].fields.TituloGaleria }}></h2>
              </div>
              <div className="row">
                {(this.props.location.state.gallery[this.state.galleryNumber].fields.Tags[0] == "Encuentros" ||
                  this.props.location.state.gallery[this.state.galleryNumber].fields.Tags[0] == "Encuentros-v") &&

                  <div className="col-md-3 col-sm-12">
                    {/* acordeon 1 */}
                    <div className="panel panel-group" id="accordion-g1">
                      <div className="panel panel-default">
                        
                        <div className="brown panel-heading">
                          <h4 className="panel-title"><a className="accordion-toggle" data-toggle="collapse" data-parent="#accordion-g1" href="#col_3-g1">Eventos en FLACSO Argentina</a></h4>
                        </div>

                        <div id="col_3-g1" className="panel-collapse collapse">
                          <div className="panel-body">

                            {this.props.location.state.gallery.map((album, index) =>
                              <div key={index}>
                              {album.fields.SubGrupo == "eventos" &&
                              <h3 key={index} onClick={() =>  this.setGalleryNumber(index)} style={{"cursor": "pointer"}}>
                                <a dangerouslySetInnerHTML={{ __html: album.fields.TituloGaleria }}></a>
                              </h3>
                              }
                              </div>
                            )}

                          </div>
                        </div>

                      </div>
                    </div>

                    {/* acordeon 2 */}
                    <div className="panel panel-group" id="accordion-g2">
                      <div className="panel panel-default">
                        
                        <div className="brown panel-heading">
                          <h4 className="panel-title"><a className="accordion-toggle" data-toggle="collapse" data-parent="#accordion-g2" href="#col_3-g2">Charlas de investigadores/as del programa</a></h4>
                        </div>

                        <div id="col_3-g2" className="panel-collapse collapse">
                          <div className="panel-body">

                            {this.props.location.state.gallery.map((album, index) =>
                              <div key={index}>
                              {album.fields.SubGrupo == "charlas" &&
                              <h3 key={index} onClick={() =>  this.setGalleryNumber(index)} style={{"cursor": "pointer"}}>
                                <a dangerouslySetInnerHTML={{ __html: album.fields.TituloGaleria }}></a>
                              </h3>
                              }
                              </div>
                            )}

                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                }

                {(this.props.location.state.gallery[this.state.galleryNumber].fields.Tags[0] != "Encuentros" &&
                  this.props.location.state.gallery[this.state.galleryNumber].fields.Tags[0] != "Encuentros-v") &&
                  
                <div className="col-md-3 col-sm-12">
                  {this.props.location.state.gallery.map((album, index) =>
                    <h3 key={index} onClick={() =>  this.setGalleryNumber(index)} style={{"cursor": "pointer"}}>
                      <a dangerouslySetInnerHTML={{ __html: album.fields.TituloGaleria }}></a>
                    </h3>
                  )}
                </div>

                }
                <div className="col-md-9 col-sm-12 about-ds-content">
                  <Gallery mainState={this.props.location.state} dato={this.state}/>
                </div>
              </div>
            </div>
          </section>

        </div>
      </div>
    )
  }
}

export default multimediaDetalle;
